<template>
	<div class="manager">
		<div class="headerBox">
			用户列表
			<el-button type="primary" plain class="addButtonClass" @click="addClick()">新建用户</el-button>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" v-loading="loading">
				<el-table-column label="序 号" width="70">
					<template slot-scope="scope"><span style="padding-left: 4px;">{{(pageIndex-1)*pageSize+scope.$index+1}}</span></template>
				</el-table-column>
				<el-table-column prop="username" label="用户名" min-width="1%">
				</el-table-column>
				<el-table-column prop="tel" label="手机号" min-width="2%">
				</el-table-column>
				<el-table-column prop="address" label="操作" min-width="1%">
					<template slot-scope="scope">
						<a class="editClass" @click.prevent="editClick(scope.row.id,scope.row)">编辑</a>
						<a class="editClass" @click.prevent="deleteClick(scope.row.id,scope.row.username)">删除</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagination">
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-if="total>20">
			</el-pagination>
		</div>
		<!--弹窗-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
			<el-form>
				<el-form-item label="用户名" label-width="20%">
					<el-input type="text" v-model="username" autocomplete="off" @change="usernameChange()"></el-input>
				</el-form-item>
				<el-form-item label="密码" label-width="20%">
					<el-input type="password" v-model="passwordValue" autocomplete="off" @change="passwordChange()" show-password></el-input>
					<el-input type="password" v-model="password" autocomplete="off" style="display: none;"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" label-width="20%">
					<el-input type="password" v-model="confirmPasswordValue" autocomplete="off" @change="confirmPasswordChange()" show-password></el-input>
					<el-input type="password" v-model="confirmPassword" autocomplete="off" style="display: none;"></el-input>
				</el-form-item>
				<el-form-item label="手机号" label-width="20%">
					<el-input type="text" v-model="tel" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="save()" class="confrim" type="primary">立即创建</el-button>
				<el-button @click="dialogFormVisible=false" class="cancle">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		mounted() {
			this.getList(); //列表
			window.addEventListener('resize', () => {
				if(document.body.clientWidth < 767) {
					this.dialogWidth = "100%"
				} else if(document.body.clientWidth < 1200) {
					this.dialogWidth = "64%"
				} else {
					this.dialogWidth = "30%"
				}
			})
		},
		created() {
			if(document.body.clientWidth < 767) {
				this.dialogWidth = "100%"
			} else if(document.body.clientWidth < 1200) {
				this.dialogWidth = "64%"
			} else {
				this.dialogWidth = "30%"
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				loading: false, //加载状态
				pageSize: 20, //每页条数
				pageIndex: 1, //当前页
				total: 0, //总条数
				tableData: [], //列表
				dialogFormVisible: false,
				title: '', //弹窗标题
				/*表单*/
				username: '', //用户名
				passwordValue: '', //密码
				password: '', //密码
				confirmPassword: '', //确认密码
				confirmPasswordValue: '', //确认密码
				tel: '', //手机号
				dialogWidth: '30%', //dialog的宽度
				editId: null, //编辑的id
				notDo: false, //不执行开关
				listRow: {}, //编辑行数据

			}
		},
		methods: {
			//每页多少
			handleSizeChange(val) {
				this.pageSize = val;
				this.getList();
			},
			//更改页数
			handleCurrentChange(val) {
				this.pageIndex = val;
				this.getList();
			},
			//总条数
			getTotal() {
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
				}
				let config = headers.headers('getListByLimitCount')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/manager/getListByLimitCount', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.total = res.data
					} else {
						this.total = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取列表
			getList() {
				this.loading = true;
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/manager/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading = false
					this.getTotal();
					//console.log(res)
					if(res.data.length > 0) {
						this.tableData = res.data

					} else {
						this.tableData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//新增用户
			addClick() {
				this.title = "新建用户"
				this.dialogFormVisible = true
				this.emptyList()
			},
			//编辑的点击
			editClick(id, list) {
				this.dialogFormVisible = true
				this.title = '编辑用户'
				this.editId = id;
				this.username = list.username
				this.password = list.password
				this.confirmPassword = list.password
				this.tel = list.tel
				this.passwordValue = ''
				this.confirmPasswordValue = ''
				this.listRow = list
			},
			//保存
			save() {
				/*创建时间的处理*/
				var timestamp = Date.parse(new Date());
				if(this.editId) { //编辑
					var params = {
						id: this.editId,
						username: this.username,
						password: this.password,
						tel: this.tel,
						status: 1,
						lev: 1,
					}
				} else {
					var params = { //添加
						username: this.username,
						password: this.password,
						tel: this.tel,
						status: 1,
						lev: 1,
						create_time: timestamp,
					}
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(!this.notDo) {
					if(this.username) {
						if(this.confirmPassword && this.password) {
							if(this.confirmPassword == this.password) {
								axios.post(this.http + '/zkep2/manager/save',
									qs.stringify(params), {
										headers: {
											'pass-token': pass_token,
											'time': timestamp
										}
									}).then(res => {
									//console.log(res)
									if(res.data.id) {
										this.dialogFormVisible = false
										this.getList()
										this.emptyList()
									} else {
										this.$message('用户名或密码错误，请重新登录！')
									}
								}).catch(err => {
									console.log(err)
								})
							} else {
								this.confirmPasswordValue = ''
							}
						} else {
							this.$message('请输入确认密码与密码！');
						}
					} else {
						this.$message('请输入必填项！')
					}
				}
			},
			//删除
			deleteClick(id, username) {
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					id: id,
					username: username + '_' + id,
					status: 0
				}
				//console.log(params)
				this.$confirm('确认要删除吗?', '注意', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					axios.post(this.http + '/zkep2/manager/save', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.getList();
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: '删除失败!'
							});
						}
					}).catch(err => {
						console.log(err)
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//清空
			emptyList() {
				this.username = ''
				this.password = ''
				this.confirmPassword = ''
				this.passwordValue = ''
				this.confirmPasswordValue = ''
				this.editId = ''
				this.tel = ''
			},
			//用户名光标离开触发
			usernameChange() {
				var params = {
					username: this.username
				}
				let config = headers.headers('getByUsername')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/manager/getByUsername', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.id) {
						if(this.editId && this.username == this.listRow.username) {
							this.notDo = false
							return
						}
						this.$message('该用户名已存在,请重新输入用户名！');
						this.notDo = true
						this.username = ''
					} else {
						this.notDo = false
						this.password = ''
						this.confirmPassword = ''
					}
				}).catch(err => {
					console.log(err)
				})
				if(this.editId) {
					this.password = ''
				}
			},
			//密码的改变
			passwordChange() {
				this.password = md5(this.passwordValue + this.username + 'eq2') //md5格式
			},
			//确认密码的改变
			confirmPasswordChange() {
				if(this.confirmPasswordValue != this.passwordValue) {
					this.$message('确认密码与密码不符，请重新输入确认密码！');
					this.confirmPasswordValue = '';
				}
				this.confirmPassword = md5(this.confirmPasswordValue + this.username + 'eq2')
			},

		}
	}
</script>

<style>
	.manager {
		height: 100%;
		padding: 4.2% 12% 0 12%;
		position: relative;
	}
	
	.manager .el-table th {
		color: #000;
	}
	
	.manager .el-table {
		font-size: 12px;
	}
	
	.manager .el-table th,
	.manager .el-table td,
	.manager .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: left;
	}
	
	.manager .el-table th {
		text-align: left;
		padding: 10px 0!important;
		font-weight: 400;
		color: #999;
	}
	
	.manager .headerBox {
		position: relative;
		height: 30px;
		line-height: 30px;
		padding: 6px 30px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
		font-size: 13px;
		margin-bottom: 10px;
	}
	
	.manager .addButtonClass {
		position: absolute;
		top: 4px;
		right: 1%;
		padding: 10px 12px;
		font-size: 13px;
	}
	
	.manager .tableBox {
		padding: 0 20px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
	}
	
	.manager .editClass {
		color: #439DFD;
		margin-right: 10px;
		cursor: pointer;
	}
	
	.manager .el-dialog__title {
		color: #999;
	}
	
	.manager .el-dialog__footer {
		text-align: center;
	}
	
	.manager .pagination {
		text-align: center;
	}
	
	.manager .pagination .el-input__inner {
		height: 30px;
		line-height: 30px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Manager/Manager.vue